import {AUTH_SUCCESS, AUTH_FAILED, RESET_PROJECT_INFO, SET_PROJECT_INFO,REFRESH_PROJECT_INFO,VULNERABLE_ONLY,TOGGLE_LANGUAGE,
    COLLAPSE_ALL, COLLAPSE_STABILITY, COLLAPSE_SECURITY, COLLAPSE_LICENSING, COLLAPSE_HISTORY, UPDATE_BADGES, SET_HISTORY_DATA, 
    SET_HISTORY_RAW, ADD_HISTORY_REPORT, STORE_HISTORY_SELECTION, SET_REPORT_READY, SET_RECOMPUTE_REMINDER, TOGGLE_ACCOUNT_INFO,
    SET_REPORT_LICENSING, TOGGLE_SECURITY_VIEWMODE, SET_JIRA_ISSUE, SET_LOCATIONS_INFO,
    SET_LIBRARY_APPROVAL, LIBRARY_APPROVAL_COMPLETED
} from '../constants/constants';

export const setAuthState = (user,successful) =>{
    if(successful){
        return {
            type: AUTH_SUCCESS,
            payload: user
        }
    }
    return{
        type: AUTH_FAILED,
        payload:null
    }
}

export const updateBadges = (badges) => {
    if (badges.securityBadge && badges.stabilityBadge) {
        return {
            type: UPDATE_BADGES,
            payload: badges
        }
    }
    return{
        type: UPDATE_BADGES,
        payload: null
    }
}

export const setReportReady = (state) => {
    return {
        type: SET_REPORT_READY,
        payload: state
    }
}

export const setProjectInfo = (projectInfo,refresh,reset)=>{
    if(!reset){
        if(!refresh){
            return{
                type: SET_PROJECT_INFO,
                payload: projectInfo
            }
        }
        if(refresh){
            return{
                type: REFRESH_PROJECT_INFO,
                payload: projectInfo
            }
        }
    }
    return{
        type: RESET_PROJECT_INFO,
        payload: null
    }
}

export const setProjectLicensingInfo = (licensingInfo)=>{
    return {
        type: SET_REPORT_LICENSING,
        payload: licensingInfo
    }
}

export const toggleAccountInfo = () => {
    return{
        type: TOGGLE_ACCOUNT_INFO
    }
}

export const filterLanguages = (languages=null)=>{
    if(!languages){
        return{
            type: VULNERABLE_ONLY,
            payload: null
        }
    }
    else{
        return{
            type: TOGGLE_LANGUAGE,
            payload: languages
        }
    }
}

export const setHistoryData = (data) => {
    return {
        type: SET_HISTORY_DATA,
        payload: data
    }
}

export const setHistoryRaw = (data) => {
    return {
        type: SET_HISTORY_RAW,
        payload: data
    }
}

export const addHistoryReport = (data) => {
    return {
        type: ADD_HISTORY_REPORT,
        payload: data
    }
}

export const storeHistorySelection = (selection) =>{
    return {
        type: STORE_HISTORY_SELECTION,
        payload: selection
    }
}

export const collapseSections = (section, current=false) => {
    if(section==="all"){
        return{
            type: COLLAPSE_ALL,
            payload: {
                "executive": !current,
                "security": !current,
                "stability": !current,
                "licensing": !current,
                "history": !current,
            }
        }
    }
    if(section==="security"){
        return{
            type: COLLAPSE_SECURITY,
            payload: !current
        }
    }
    if(section==="stability"){
        return{
            type: COLLAPSE_STABILITY,
            payload:!current
        }
    }
    if(section==="licensing"){
        return{
            type: COLLAPSE_LICENSING,
            payload: !current
        }
    }
    if(section==="history"){
        return{
            type: COLLAPSE_HISTORY,
            payload: !current
        }
    }
    return {
        type: "NO_TYPE",
        payload: null
    }
}

export const setRecomputeReminder = ( recomputed ) => {
    return {
        type: SET_RECOMPUTE_REMINDER,
        payload: recomputed
    }
}
export const toggleSecurityViewMode = () => {
    return {
        type: TOGGLE_SECURITY_VIEWMODE
    }
}

export const setJiraIssue = (info) => {
    return {
        type: SET_JIRA_ISSUE,
        payload: info
    }
}


export const setLocationsInfo = (library) => {
    return {
        type: SET_LOCATIONS_INFO,
        payload: library
    }
}

// Opens the create-a-library-policy modal by putting what it needs in the
// store - the violation, the offending version and the team the policy is
// created for. Called with null it closes it again.
export const setLibraryApproval = (pendingApproval) => {
    return {
        type: SET_LIBRARY_APPROVAL,
        payload: pendingApproval
    }
}

// The modal created the policy: this closes it and records which approval was
// completed, which is how the Approve button that opened it - rendered far
// away in the advice list - learns to repaint itself as "Approved".
export const libraryApprovalCompleted = (adviceId, version) => {
    return {
        type: LIBRARY_APPROVAL_COMPLETED,
        payload: { adviceId: adviceId, version: version }
    }
}